const Address = require('./Address');
const Provider = require('./Provider');

class AdminUnit {
  constructor() {
    this.init();
  }

  init() {
    this.admin_unit_id = undefined;
    this.name = '';
    this.email = '';
    this.contact = undefined;
    this.phone_number = undefined;
    this.address = new Address();
    this.logo_url = undefined;
    this.has_waitlist_form = undefined;
    this.providers = [];
  }

  copy() {
    const cp = new AdminUnit();

    cp.admin_unit_id = this.admin_unit_id;
    cp.name = this.name;
    cp.email = this.email;
    cp.contact = this.contact;
    cp.phone_number = this.phone_number;
    cp.address = this.address;
    cp.providers = [];
    cp.logo_url = this.logo_url;
    cp.has_waitlist_form = this.has_waitlist_form;
    this.providers.forEach((p) => {
      cp.providers.push(p.copy());
    });
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.admin_unit_id = obj.admin_unit_id ? obj.admin_unit_id.toString() : undefined;
      this.name = obj.name ? obj.name : '';
      this.email = obj.email? obj.email: '';
      this.contact = obj.contact ? obj.contact : undefined;
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.address.buildFromJSON(obj.address ? obj.address : {});
      this.logo_url = obj.logo_url ? obj.logo_url : undefined;
      this.has_waitlist_form = (obj.has_waitlist_form !== undefined) ? obj.has_waitlist_form : undefined;

      this.providers = [];
      if (obj.providers) {
        obj.providers.forEach((p) => {
          const provider = new Provider();
          provider.buildFromJSON(p);
          this.providers.push(provider);
        });
      }
    }
  }

  toString() {
    let result = this.name;
    const address = this.address.toString();

    if (this.admin_unit_id) {
      result = (result.length) ? `${result} (${this.admin_unit_id})` : `${this.admin_unit_id}`;
    }
    if (address.length) {
      result = (result.length) ? `${result}: ${address}` : address;
    }

    return result;
  }

  getId() {
    return this.admin_unit_id;
  }

  setId(admin_unit_id) {
    this.admin_unit_id = admin_unit_id ? admin_unit_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getContact() {
    return this.contact;
  }

  setContact(contact) {
    this.contact = contact;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }
  
  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }

  getLogoUrl() {
    return this.logo_url;
  }

  setLogoUrl(logo_url) {
    this.logo_url = logo_url;
  }

  getHasWaitlistForm() {
    return this.has_waitlist_form;
  }

  setHasWaitlistForm(has_waitlist_form) {
    this.has_waitlist_form = (has_waitlist_form !== undefined) ? has_waitlist_form : undefined;
  }
  
  getProviders() {
    return this.providers;
  }

  setProviders(providers) { 
    this.providers = [];

    if (providers && Array.isArray(providers)) {
      providers.forEach((p) => {
        this.providers.push(p.copy());
      });
    }

  }
}

module.exports = AdminUnit;
